import { gql } from "@apollo/client";

export const getEcUserQuerry=gql`
query Ec_Users($phone_number: String = "", $qr_code: String = "") {
  ec_users(where: {phone_number: {_eq: $phone_number}}) {
    id
    name
  }
  ec_cards(where: {qr_code: {_eq: $qr_code}}) {
    id
    user_id
  }
}
`